import { Auth0AccountRole, StudentLimitedResponse } from "client/openapi";
import Communication from "pages/manage/ProfilePageResources/CommunicationBox/Communication";
import Notes from "pages/manage/ProfilePageResources/NotesBox/Notes";
import { useContext } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";

export default function NotesTab({
  student,
}: {
  student: StudentLimitedResponse;
}) {
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);

  return (
    <div className="grid grid-cols-1 gap-y-5 md:grid-cols-2">
      {currently_selected_role &&
        [Auth0AccountRole.ORG_ADMIN, Auth0AccountRole.ORG_TUTOR].includes(
          currently_selected_role
        ) && (
          <>
            <div className="flex justify-center mx-5 mt-5 md:justify-end md:mx-0 md:mt-0">
              <Notes
                title="Internal Notes"
                student={student}
                toolTipMessage="These notes are private to this student's profile."
              />
            </div>
            <div className="flex justify-center mx-5 mt-5 md:justify-end md:mx-0 md:mt-0">
              <Communication
                title="Communication"
                student={student}
                toolTipMessage="This represents inbound and outbound communication with this student."
              />
            </div>
          </>
        )}
    </div>
  );
}
